import { Modal } from 'antd';

const GlobalDrawer = ({
  open,           
  onClose,
  drawerHeading,
  children,
  ...otherProps
}) => {
  return (
    <Modal
     
      open={open}
      onCancel={onClose}
      centered 
      closable={false}
      footer={null} 
      width={'20vw'}
      
      

    styles={{
        // Removes padding from the outer modal container
        content: { padding: 0, overflow: 'hidden',borderRadius: '15px' },
        // Removes padding from the inner body
        body: { padding: 0, margin: 0 } 
      }}
      {...otherProps}
    >
      <div style={{ minHeight: '83vh' ,width: '100%'}}>
        {children}
      </div>
    </Modal>
  );
};

export default GlobalDrawer;